import { Component, OnInit,AfterViewInit} from '@angular/core';
import {HomeComponent} from '../home/home.component';

declare var $:any;


@Component({
  selector: 'app-page-404',
  templateUrl: './page-404.component.html',
  styleUrls: ['./page-404.component.css']
})
export class Page404Component implements OnInit,AfterViewInit {

  planId:number=-1;
  userTypeId:number=-1;
  isNext:boolean=false;
  constructor(private home:HomeComponent) { }

  ngOnInit() {
    this.userTypeId=localStorage.getItem("UserTypeId")==null ? -1 : parseInt(localStorage.getItem("UserTypeId"));
    this.planId=localStorage.getItem("planId")==null ? -1 : parseInt(localStorage.getItem("planId"));

  }

  ngAfterViewInit(){
    $('.cd-header').css('background-color','#941246')
  }

  showActiveModule(pvarId){
    this.home.showActiveModule(pvarId);
  }


}



// WEBPACK FOOTER //
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/page-404/page-404.component.ts